/**
 * Centralised TanStack Query keys for the salaries resource.
 *
 * A **posted** payroll entry moves three things at once — the register's accrued
 * figures, the journal and the account balances they are compared against — so
 * `useInvalidatePostedPayrollEntry` invalidates all three. Keeping the keys here
 * is what lets that stay a one-liner instead of three drifting string literals.
 */
export const SalaryQueryKeys = {
    all: ['salaries'] as const,
    employees: (status: string, search: string) =>
        [...SalaryQueryKeys.all, 'employees', status, search] as const,
    runs: () => [...SalaryQueryKeys.all, 'runs'] as const,
    /** A run is addressed by its **journal entry id** — it has no other identity. */
    run: (journalEntryId: string) =>
        [...SalaryQueryKeys.all, 'run', journalEntryId] as const,
};
